var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app1"}},[_c('div',{ref:"myEchart1",staticStyle:{"height":"600px","width":"800px"},attrs:{"id":"chinaMap1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }